/* unplugin-vue-components disabled */import script from "./FullScreenBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./FullScreenBtn.vue?vue&type=script&setup=true&lang=ts"

import "./FullScreenBtn.vue?vue&type=style&index=0&id=38f31659&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38f31659"]])

export default __exports__